/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const DashBoardLayout = () => {
  return (
    <div className="flex">
      <Sidebar />

      <main className="w-[100%] p-6 bg-background_img bg-cover bg-no-repeat">
        {<Outlet />}
      </main>
    </div>
  );
};

export default DashBoardLayout;
